import $ from 'jquery';

import ChairishABTest from 'chairisher/abtest';
import createProductRail from 'chairisher/view/helper/rail';
import FavoriteProductView from 'chairisher/view/product/favorite';
import RepeatingScroller from 'chairisher/component/scroller/repeating';

import { getSaleUrl } from 'chairisher/context/product';
import { ProductRailType } from 'chairisher/util/analytics';

/**
 * AB Test that shows a personalized rail at the top of the Sale page to help users quickly find relevant products
 * and increase conversion. The rail uses the same logic as Temp Sale emails and is visible to all users.
 *
 * TODO: (CHAIR-17960) Delete file after AB test is complete.
 */
export default class TempSaleRailTest extends ChairishABTest {
    static getExperimentName() {
        return 'TEMP_SALE_RAIL_AB_TEST';
    }

    variation() {
        const railIdSelector = '#js-temp-sale-rail';
        const $railContainerEl = $(railIdSelector);
        const $collectionTitle = $('.js-collection-header .collection-title');
        const $railSelectorEl = $(`${railIdSelector}-scrollable-grid`);

        createProductRail({
            $el: $railSelectorEl,
            $containerEl: $railContainerEl,
            analyticsTrackingType: ProductRailType.TEMP_SALE,
            listSelector: railIdSelector,
            railUrl: getSaleUrl(),
            onRendered: () => {
                const $products = $railContainerEl.find('.js-product');

                if ($products.length) {
                    // If this variant wins, sync this value with minNumProductsToDisplayThreshold in ProductRail to avoid inconsistency.
                    if ($products.length >= 3) {
                        $collectionTitle.text('All On Sale');
                    }

                    $products.each((i, el) => {
                        const $productEl = $(el);
                        if ($productEl.data('is-favorited')) {
                            const id = $productEl.data('product-id');
                            FavoriteProductView.addProductId(id, false);
                            FavoriteProductView.drawButton(true, id);
                        }
                    });
                    RepeatingScroller.createProductScroller($railSelectorEl, { shouldAutoScroll: false });
                }
            },
        });
    }
}
